function KeysListController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.sortType = 'created'; // set the default sort type
    ctrl.sortReverse = true; // set the default sort order
    ctrl.packageExistsTooltip = 'Package already exists for this key. Only one package can be created per key.';
  };

  ctrl.$onChanges = changes => {
    if (changes.keys && ctrl.keys) translateTypes(ctrl.keys);
  };

  const translateTypes = keys => keys.map(key => {
    if (key.keyType === 'SSH' && key.keyTarget === 'TRAIN') key.translatedType = 'SSH';
    if (key.keyType === 'RSA' && key.keyTarget === 'TRAIN') key.translatedType = 'Train signing key';
    if (key.keyType === 'RSA' && key.keyTarget === 'SMARTVISION') key.translatedType = 'SmartVision signing key';
  });

  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };

  ctrl.generate = key => {
    ctrl.onGenerate({
      $event: {
        key: key,
      }
    });
  };
}

angular
  .module('key-manager.module')
  .controller('KeysListController', KeysListController);
